import {
  DeepMap,
  FieldError,
  FieldValues,
  UseFormRegisterReturn,
} from "react-hook-form";
import MaterialIcon, { MtIcon } from "../../material-icon/material-icon";
import styles from "./app-dual-input.module.scss";

export type FieldErrors<TFieldValues extends FieldValues = FieldValues> =
  DeepMap<TFieldValues, FieldError>;

interface IFieldProps {
  name: string;
  placeholder: string;
  register?: UseFormRegisterReturn;
  type?: string;
  disabled?: boolean;
  value?: string;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  onKeyDown?: React.KeyboardEventHandler<HTMLInputElement>;
}

interface IProps {
  leftField: IFieldProps;
  rightField: IFieldProps;
  leftIcon?: MtIcon;
  errors: FieldErrors;
  className?: string;
  isError?: boolean;
  isSuccess?: boolean;
}

const AppDualInput = (props: IProps) => {
  const {
    leftField,
    rightField,
    leftIcon,
    errors,
    className,
    isError,
    isSuccess,
  } = props;

  const hasLeftError = leftField.name && errors[leftField.name]?.message;
  const hasRightError = rightField.name && errors[rightField.name]?.message;
  const hasAnyError = hasLeftError || hasRightError || isError;

  const getContainerClass = () => {
    if (hasAnyError) return `${styles.container} ${styles.hasDanger}`;
    if (isSuccess) return `${styles.container} ${styles.hasSuccess}`;
    return styles.container;
  };

  return (
    <div className={`${styles.wrapper} ${className || ""}`}>
      <div className={getContainerClass()}>
        <div className={styles.leftHalf}>
          {leftIcon && (
            <div className={styles.leftIcon}>
              <MaterialIcon icon={leftIcon} color={"#7483cc"} size={18} />
            </div>
          )}
          <input
            {...leftField.register}
            placeholder={leftField.placeholder}
            type={leftField.type}
            disabled={leftField.disabled}
            value={leftField.value}
            onChange={leftField.onChange ?? leftField.register?.onChange}
            onKeyDown={leftField.onKeyDown}
            className={`${styles.input} ${leftField.disabled ? styles.disabled : ""}`}
          />
        </div>
        <div className={styles.divider}></div>
        <input
          {...rightField.register}
          placeholder={rightField.placeholder}
          type={rightField.type}
          disabled={rightField.disabled}
          value={rightField.value}
          onChange={rightField.onChange ?? rightField.register?.onChange}
          onKeyDown={rightField.onKeyDown}
          className={`${styles.input} ${styles.rightInput} ${rightField.disabled ? styles.disabled : ""}`}
        />
      </div>
      {(hasLeftError || hasRightError) && (
        <div className={styles.errorContainer}>
          {hasLeftError && (
            <span className="error">{errors[leftField.name]?.message}</span>
          )}
          {hasRightError && (
            <span className="error">{errors[rightField.name]?.message}</span>
          )}
        </div>
      )}
    </div>
  );
};

export default AppDualInput;
